import React, { useState, useEffect, useCallback } from 'react';
import { fetchSermonFeedbackAnalytics } from '../../api/client';
import SermonFeedbackAnalytics from '../SermonFeedbackAnalytics/SermonFeedbackAnalytics';
import SermonFeedbackList from '../SermonFeedbackList/SermonFeedbackList';

export default function SermonFeedbackTab() {
  const [analytics, setAnalytics] = useState(null);

  const loadAnalytics = useCallback(async () => {
    try {
      const res = await fetchSermonFeedbackAnalytics();
      setAnalytics(res.data);
    } catch (_e) {
      setAnalytics(null);
    }
  }, []);

  useEffect(() => {
    loadAnalytics();
  }, [loadAnalytics]);

  return (
    <div>
      <SermonFeedbackAnalytics analytics={analytics} />
      <SermonFeedbackList />
    </div>
  );
}
